import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import businessesReducer from './slices/businessesSlice';
import calendarReducer from './slices/calendarSlice';
import contactReducer from './slices/contactSlice';
import dashboardReducer from './slices/dashboardSlice';
import dealsReducer from './slices/dealsSlice';
import integrationReducer from './slices/integrationSlice';
import leadsReducer from './slices/leadsSlice';
import pricingIntelligenceAndServicesReducer from './slices/pricingIntelligenceAndServicesSlice';
import rolesAndPermissionsReducer from './slices/rolesAndPermissionsSlice';
import teamUiReducer from './slices/teamUiSlice';
import toastReducer from './slices/toastSlice';

export const store = configureStore({
  reducer: {
    calendar: calendarReducer,
    dashboard: dashboardReducer,
    rolesAndPermissions: rolesAndPermissionsReducer,
    integration: integrationReducer,
    auth: authReducer,
    leads: leadsReducer,
    contacts: contactReducer,
    deals: dealsReducer,
    pricingIntelligenceAndServices: pricingIntelligenceAndServicesReducer,
    businesses: businessesReducer,
    teamUi: teamUiReducer,
    toast: toastReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
